import { VariantChangeBase } from '@theme/global';

class SouthwoodProductPayments extends VariantChangeBase {
  onVariantChanged(event) {
    const variant = event.detail.variant;
    this.hidden = !variant;
    if (!variant) return;
    const amount = (variant.price / 100).toFixed(2);
    const paypal = this.querySelector('[data-pp-message]');
    if (paypal) {
      paypal.setAttribute('data-pp-amount', amount);
      if (window.PayPalSDK?.Messages) {
        Promise.resolve(window.PayPalSDK.Messages({ amount }).render(paypal)).catch(() => {});
      }
    }
    const clearpay = this.querySelector('square-placement');
    if (clearpay) {
      clearpay.setAttribute('data-amount', amount);
      clearpay.setAttribute('data-item-skus', variant.sku || String(variant.id));
    }
  }
}
if (!customElements.get('sw-product-payments')) {
  customElements.define('sw-product-payments', SouthwoodProductPayments);
}

function prepareProductTabs() {
  const mobile = window.matchMedia('(max-width: 767px)').matches;
  document.querySelectorAll('.hdt-type-tab-accordion .hdt-product-accordion__item').forEach(details => {
    details.open = !mobile;
    details.querySelector('summary')?.setAttribute('aria-expanded', String(!mobile));
  });
}

document.addEventListener('click', event => {
  const link = event.target.closest('a[data-sw-description], a[data-sw-reviews]');
  if (!link) return;
  const isReviews = link.hasAttribute('data-sw-reviews');
  const target = document.getElementById(isReviews ? 'southwood-product-reviews' : 'southwood-product-description');
  if (!target) return;
  event.preventDefault();
  if (isReviews) event.stopImmediatePropagation();
  const scrollToDescription = () => requestAnimationFrame(() => {
    target.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  const item = target.closest('[tab-item]');
  const tabList = item?.closest('.hdt-product-tab__wrap')?.querySelector('.hdt-product-tab__main');
  if (item && tabList && window.matchMedia('(min-width: 768px)').matches) {
    const items = [...item.parentElement.children].filter(element => element.hasAttribute('tab-item'));
    if (!item.hasAttribute('tab-selected')) {
      const observer = new MutationObserver(() => {
        if (!item.hasAttribute('tab-selected')) return;
        observer.disconnect();
        scrollToDescription();
      });
      observer.observe(item, { attributes: true, attributeFilter: ['tab-selected'] });
      tabList.children[items.indexOf(item)]?.click();
      return;
    }
    tabList.children[items.indexOf(item)]?.click();
  }
  const details = target.closest('details');
  if (details) {
    details.open = true;
    details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  }
  scrollToDescription();
}, true);

prepareProductTabs();
window.matchMedia('(max-width: 767px)').addEventListener('change', prepareProductTabs);
document.addEventListener('shopify:section:load', prepareProductTabs);


function alignDesktopProductGallery() {
  const media = document.querySelector('.hdt-section--feature-product .hdt-product-media');
  const info = document.querySelector('.hdt-section--feature-product .hdt-product-info__list');
  if (!media || !info || media.dataset.swAligned) return;
  media.dataset.swAligned = 'true';
  const desktop = window.matchMedia('(min-width: 1150px)');
  const update = () => {
    if (desktop.matches) media.style.setProperty('--sw-product-frame-height', info.getBoundingClientRect().height + 'px');
    else media.style.removeProperty('--sw-product-frame-height');
  };
  new ResizeObserver(update).observe(info);
  desktop.addEventListener('change', update);
  update();
}
alignDesktopProductGallery();
document.addEventListener('shopify:section:load', alignDesktopProductGallery);

function protectMobileProductModels(root = document) {
  root.querySelectorAll('hdt-product-media hdt-model-player').forEach(player => {
    if (player.dataset.swMobileModelGestures) return;
    player.dataset.swMobileModelGestures = 'true';
    const keepModelGesture = event => {
      if (window.matchMedia('(max-width: 767px)').matches) event.stopPropagation();
    };
    ['touchstart', 'pointerdown', 'mousedown'].forEach(type => {
      player.addEventListener(type, keepModelGesture, { passive: true });
    });
  });
}

protectMobileProductModels();
document.addEventListener('shopify:section:load', event => protectMobileProductModels(event.target));
